import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "Inner",
  componentId: "sc-6v9qjn-0"
})(["display:block;width:100%;"]);